import { Box, Typography } from "@mui/material";
import ResourcePageGrid from "components/forum/ResourcePageGrid";
import FlexPage from "components/layout/FlexPage";

export default () => {
  return (
    <FlexPage sx={{ gap: "24px" }}>
      <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        <Typography variant="display">Help</Typography>
        <Typography variant="body">
          Common resources to help & support for advisors, please feel free to
          contact us directly or drop a note to{" "}
          <a
            href={`/inbox/email/create?email=${encodeURIComponent(
              "support@findfaye.com",
            )}`}
            style={{
              textDecoration: "none",
              color: "#198282",
              fontWeight: "600",
              cursor: "pointer",
            }}
          >
            support@findfaye.com
          </a>{" "}
          for additional needs.
        </Typography>
      </Box>
      <Box sx={{ marginBottom: "32px" }}>
        <ResourcePageGrid page="help" />
      </Box>
    </FlexPage>
  );
};
